"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedInterleavedPoint2dQuadIndexer = void 0;
const rc_js_util_1 = require("rc-js-util");
const e_cartesian2d_user_transform_1 = require("../../../update/user-transforms/e-cartesian2d-user-transform");
/**
 * @public
 * Base 2d point quad indexer.
 */
class SharedInterleavedPoint2dQuadIndexer {
    constructor(wrapper, prefix, offsetMethodName) {
        this.wrapper = wrapper;
        this.cIndex = `_${prefix}_index`;
        const offsets = BigInt.asUintN(64, BigInt(this.wrapper.instance[offsetMethodName]()));
        const size = Number(offsets & BigInt(0xFF));
        this.connectorOffset = Number((offsets >> BigInt(8)) & BigInt(0xFF));
        this.displayConfigOffset = Number((offsets >> BigInt(16)) & BigInt(0xFF));
        this.offsetsOffset = Number((offsets >> BigInt(24)) & BigInt(0xFF));
        this.sizeTransformOffset = Number((offsets >> BigInt(32)) & BigInt(0xFF));
        this.worldTransformOffset = Number((offsets >> BigInt(40)) & BigInt(0xFF));
        this.rvp = rc_js_util_1.RawVoidPointer.createOne(wrapper, size, true);
        this.sharedObject = this.rvp.sharedObject;
    }
    static createOne(wrapper, prefix, inputType) {
        const offsetMethodName = inputType.BYTES_PER_ELEMENT === 4
            ? `_f32Interleaved2dQuadIndexer_getOffsets`
            : `_f64Interleaved2dQuadIndexer_getOffsets`;
        return new SharedInterleavedPoint2dQuadIndexer(wrapper, prefix, offsetMethodName);
    }
    addToTree(tree, entity, worldTransform, userTransform) {
        const connector = entity.data;
        const dataView = this.rvp.getDataView();
        dataView.setUint32(0, tree.sharedObject.getPtr(), SharedInterleavedPoint2dQuadIndexer.littleEndian);
        dataView.setUint32(this.connectorOffset, connector.sharedObject.getPtr(), SharedInterleavedPoint2dQuadIndexer.littleEndian);
        dataView.setInt8(this.displayConfigOffset, userTransform.xTransformEnabled ? userTransform.transformId : e_cartesian2d_user_transform_1.ECartesian2dUserTransform.Identity);
        dataView.setInt8(this.displayConfigOffset + 1, userTransform.yTransformEnabled ? userTransform.transformId : e_cartesian2d_user_transform_1.ECartesian2dUserTransform.Identity);
        dataView.setUint16(this.displayConfigOffset + 2, entity.graphicsSettings.pointDisplay.getPixelSize(), SharedInterleavedPoint2dQuadIndexer.littleEndian);
        dataView.setInt8(this.offsetsOffset, connector.offsets.x);
        dataView.setInt8(this.offsetsOffset + 1, connector.offsets.y);
        dataView.setInt8(this.offsetsOffset + 2, connector.offsets.size == null ? -1 : connector.offsets.size);
        dataView.setInt8(this.offsetsOffset + 3, connector.offsets.color == null ? -1 : connector.offsets.color);
        entity.graphicsSettings.pointSizeNormalizer
            .getSizeToPixelTransform()
            .copyToBuffer(dataView, this.sizeTransformOffset);
        worldTransform.copyToBuffer(dataView, this.worldTransformOffset);
        this.wrapper.instance[this.cIndex](this.rvp.sharedObject.getPtr(), entity.hitTestId, entity.groupMask);
    }
}
exports.SharedInterleavedPoint2dQuadIndexer = SharedInterleavedPoint2dQuadIndexer;
SharedInterleavedPoint2dQuadIndexer.littleEndian = rc_js_util_1.isLittleEndian;
//# sourceMappingURL=shared-interleaved-point-2d-quad-indexer.js.map